import React, { useState } from 'react';
import { CSVLink } from 'react-csv';
import { getOr, stubString, times, size } from 'lodash/fp';
import ImportItemColumns from '../../../constants/inventory/ImportItemColumns';

const SampleRow = [
  'string',
  'string',
  '0.0000',
  '0.00',
  '0',
  '100',
  '500',
  'G/Y/R or Blank',
  'Tag1,Tag2'
];

function DownloadItemsFormat(props) {
  const [csvData, setCsvData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = e => {
    if (isLoading) {
      e.preventDefault();
      return;
    }
    setIsLoading(true);
    const EmptyRow = times(stubString, size(SampleRow));
    const DataRows = [SampleRow, ...times(() => EmptyRow, 99)];
    setCsvData([ImportItemColumns, ...DataRows]);
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };
  return (
    <CSVLink
      data={csvData}
      onClick={handleClick}
      target="_blank"
      className="rs-dropdown-item-content"
      filename="inventory-items-template.csv"
      style={isLoading ? { opacity: 0.3, cursor: 'not-allowed' } : {}}
    >
      {isLoading
        ? 'Downloading...'
        : getOr('Get Items Format', 'children', props)}
    </CSVLink>
  );
}

export default DownloadItemsFormat;
